import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getQuestionsRequest } from "../services/apiService";

interface IDemographicState {
  demographicQues: [];
  isLoader: boolean;
  error: any;
  count: number;
  page: number;
}

const initialState: IDemographicState = {
  demographicQues: [],
  isLoader: false,
  error: "",
  count: 0,
  page: 0
};

export const getDemographicQues = createAsyncThunk(
  "retrieve/demographicQuesion",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response: any = await getQuestionsRequest(payload);
      return response;
    } catch (error: any) {
      throw rejectWithValue(error.message)
    }
  }
);

// Then, handle actions in your reducers:
const demographicSlice = createSlice({
  name: 'demographic',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getDemographicQues.pending, (state: IDemographicState, action) => {
        state.isLoader = true;
      })
      .addCase(getDemographicQues.fulfilled, (state: IDemographicState, action) => {
        const { payload } = action;
        state.demographicQues = payload.data
        state.isLoader = false
        state.count = payload.count
        state.page = payload.page
      })
      .addCase(getDemographicQues.rejected, (state: IDemographicState, action) => {
        state.isLoader = false;
        state.error = action.payload;
      })
  },
});

const { reducer } = demographicSlice;
export default reducer;